import { Location } from "history";
import { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 Makes a callback to route to a link, where you bake in any parameters
 i.e.
 const linkToCourse = (courseId) => `/some/path/${courseId}`

 const navigateToCourse = useSimpleNavigationCallback(linkToCourse('someCourseId'))

 // No params needed
 navigateToCourse()
 
 If you need to pass params at the call site (i.e. navigateToCourse('someCourseId')) see useNavigationCallback
 */

type SimpleLink = () => void;

export default function useSimpleNavigationCallback(
  link: string | Location
): SimpleLink {
  const history = useHistory();

  const linkRef = useRef(link);

  useEffect(() => {
    linkRef.current = link;
  }, [link]);

  return useCallback(() => {
    history.push(linkRef.current as string);
  }, [history]);
}
